import { create } from "zustand";

import type { UrlOrganisation } from "components/entry/types";

export type SessionState = {
  urlOrganisation: UrlOrganisation | null;
  demoingTour: string;
  hasSeenIdeaLikeInformationModalThisSession: boolean;
  utmLink: string;
  utmChallenge: string;
  /** Set after /users/me records the referral; App then strips the URL params. */
  clearUtm: boolean;
};

export const initialSessionState: SessionState = {
  urlOrganisation: null,
  demoingTour: "",
  hasSeenIdeaLikeInformationModalThisSession: false,
  utmLink: "",
  utmChallenge: "",
  clearUtm: false,
};

export const useSessionStore = create<SessionState>(() => ({
  ...initialSessionState,
}));

/** Clears tour/UTM/modal flags but keeps the URL organisation for branded login. */
export const resetSession = () => {
  const { urlOrganisation } = useSessionStore.getState();
  useSessionStore.setState({ ...initialSessionState, urlOrganisation });
};
